module.exports = __webpack_public_path__ + "static/media/1.524b0036.webp";